import { isValidElement } from 'react';
/** Flattens an option's rendered content into the text a sheet search can match. */
export const collectOptionText = (node) => {
    if (node == null || typeof node === 'boolean') {
        return '';
    }
    if (typeof node === 'string' || typeof node === 'number') {
        return String(node);
    }
    if (Array.isArray(node)) {
        return node.map(collectOptionText).join(' ');
    }
    if (isValidElement(node)) {
        const props = node.props;
        return collectOptionText(props.children);
    }
    return '';
};
//# sourceMappingURL=dropdown_option_text.utils.js.map